import { Component, AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-tracking',
    templateUrl: './tracking.component.html',
    styleUrls: ['./tracking.component.css'],
    standalone: false
})
export class TrackingComponent implements AfterViewInit
{
  ngAfterViewInit()
  {
    window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "Tracking" }));
  }
}
